// import React from 'react'

// const LeadDetails = () => {
//   return (
//     <div>LeadDetails</div>
//   )
// }

// export default LeadDetails

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef } from 'react'
import { createPortal } from 'react-dom'
import { Modal } from 'react-bootstrap'
import 'react-time-picker/dist/TimePicker.css'
import 'react-clock/dist/Clock.css'
import '../LeadManagementStyles/LeadManagementStyle.module.scss'
import '../LeadManagementStyles/LeadManagementStyle.module.css'

const modalsRoot = document.getElementById('root-modals') || document.body

const LeadDetails = ({
    show,
    handleClose,
    data
}: any) => {
    const modalHeaderRef = useRef<HTMLDivElement>(null)
    return createPortal(
        <Modal
            id='kt_modal_create_app'
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered mw-900px'
            show={show ? true : false}
            onHide={handleClose}
            backdrop={true}
        >
            {/* Begin: Modal header */}
            <div className='modal-header pt-5 pb-5' ref={modalHeaderRef}>
                {/* Begin: Modal Heading */}
                <h2>Lead Details</h2>
                {/* End: Modal Heading */}
                {/* Begin::Close button */}
                <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
                    <i className='bi bi-x-lg' onClick={handleClose}></i>
                </div>
                {/* end::Close button */}
            </div>
            {/* End: Modal header */}

            {/* Begin: Modal body */}
            <div className='modal-body p-0'>

                <div className='card-body p-9 row'>
                    {/* Begin: heading Contact details */}
                    <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>Contact details</h2>
                    {/* End: heading Contact details */}
                    {/* Begin: left column */}
                    <div className='col-md-6'>
                        {/* Begin: Detail field Full Name */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Full Name</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>
                                    {data.full_name ? data.full_name : '-'}
                                </span>
                            </div>
                        </div>
                        {/* End: Detail field Full Name */}
                        {/* Begin: Detail field Email ID */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Email ID</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>
                                    {data.email ? data.email : "-"}
                                </span>
                            </div>
                        </div>
                        {/* End: Detail field Email ID */}
                        {/* Begin: Detail field Address */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Address</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>{(data.address_1 || data.address_2 || data.state || data.city || data.pincode) ? `${data.address_1 && data.address_1}${data.address_2 && `, ${data.address_2}`}${data.state && `, ${data.state}`}${data.city && `, ${data.city}`}${data.pincode && ` - ${data.pincode}`}` : "-"}</span>
                            </div>
                        </div>
                        {/* End: Detail field Address */}
                    </div>
                    {/* End: left column */}
                    {/* Begin: Right column */}
                    <div className='col-md-6'>
                        {/* Begin: Detail field Phone Number */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Phone Number</label>
                            <div className='col-lg-6 d-flex align-items-center'>
                                <span className='fw-bold fs-6 pb-1 me-2'>
                                    {data.phone_number ? data.phone_number : "-"}
                                </span>
                            </div>
                        </div>
                        {/* End: Detail field Phone Number */}
                        {/* Begin: Detail field Preferred Contact Method */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Preferred Contact Method</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1 text-dark pb-1'>
                                    {data.contact_mode? (Array.isArray(data.contact_mode)? data.contact_mode.join(", "): data.contact_mode) : "-"}
                                </span>
                            </div>
                        </div>
                        {/* End: Detail field Preferred Contact Method */}
                    </div>
                    {/* End: Right column */}


                    {/* Begin: heading Property Preferences */}
                    <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>Property Preferences</h2>
                    {/* End: heading Property Preferences */}
                    {/* Begin: left column */}
                    <div className='col-md-6'>
                        {/* Begin: Detail field Preferred Location */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Preferred Location</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1 text-dark pb-1'>
                                    {data.prefferd_loc ? data.prefferd_loc : "-"}
                                </span>
                            </div>
                        </div>
                        {/* End: Detail field Preferred Location */}
                        {/* Begin: Detail field Number of bedrooms */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Number of bedrooms</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>
                                    {data.no_room ? data.no_room : "-"}
                                </span>
                            </div>
                        </div>
                        {/* End: Detail field Number of bedrooms */}
                        {/* Begin: Detail field Min Price Range */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Min Price Range</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>{data.min_price ? `₹${data.min_price}` : "-"}</span>
                            </div>
                        </div>
                        {/* End: Detail field Min Price Range */}
                        {/* Begin: Detail field Pet-Friendly Preference */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Pet-Friendly Preference</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>
                                    {data.pet_friendly ? data.pet_friendly.charAt(0).toUpperCase() + data.pet_friendly.slice(1) : "-"}
                                </span>
                            </div>
                        </div>
                        {/* End: Detail field Pet-Friendly Preference */}
                        {/* Begin: Detail field Preferred Rental Duration in Years */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Preferred Rental Duration in Years</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>{data.tenancy_period ? data.tenancy_period : "-"}</span>
                            </div>
                        </div>
                        {/* End: Detail field Preferred Rental Duration in Years */}
                    </div>
                    {/* End: left column */}
                    {/* Begin: right column */}
                    <div className='col-md-6'>
                        {/* Begin: Detail field Property Type */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Property Type</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>
                                    {data.property_type ? data.property_type : "-"}
                                </span>
                            </div>
                        </div>
                        {/* End: Detail field Property Type */}
                        {/* Begin: Detail field Number of Bathrooms */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Number of Bathrooms</label>
                            <div className='col-lg-6 fv-row'>
                                <span className='fw-bold fs-6 pb-1'>{data.no_toilet ? data.no_toilet : "-"}</span>
                            </div>
                        </div>
                        {/* End: Detail field Number of Bathrooms */}
                        {/* Begin: Detail field Max Price Range */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Max Price Range</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>{data.max_price ? `₹${data.max_price}` : "-"}</span>
                            </div>
                        </div>
                        {/* End: Detail field Max Price Range */}
                        {/* Begin: Detail field Preferred Move-In Date */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Preferred Move-In Date</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1 text-dark pb-1'>
                                    {data.tenancy_start ? data.tenancy_start : "-"}
                                </span>
                            </div>
                        </div>
                        {/* End: Detail field Preferred Move-In Date */}
                    </div>
                    {/* Begin: right column */}


                    {/* Begin: heading Income / Employment Details */}
                    <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>Income / Employment Details</h2>
                    {/* End: heading Income / Employment Details */}

                    {/* Begin: left column */}
                    <div className='col-md-6'>
                         {/* Begin: Detail field Employment Type */}
                         <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Employment Type</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>{data.employment_type ? data.employment_type : "-"}</span>
                            </div>
                        </div>
                        {/* End: Detail field Employment Type */}
                        {/* Begin: Detail field Monthly Income */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Monthly Income</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>{data.monthly_income ? data.monthly_income : "-"}</span>
                            </div>
                        </div>
                        {/* End: Detail field Monthly Income */}
                    </div>
                    {/* End: left column */}

                    {/* Begin: Right column */}
                    <div className='col-md-6'>                       
                        {/* Begin: Detail field Length of Employment in Years */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Length of Employment in Years</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>{data.employment_length ? data.employment_length : "-"}</span>
                            </div>
                        </div>
                        {/* End: Detail field Length of Employment in Years */}
                        {/* Begin: Detail field Other Requirements */}
                        <div className='row mb-6'>
                            <label className='col-lg-6 fw-bold text-muted'>Other Requirements</label>
                            <div className='col-lg-6'>
                                <span className='fw-bold fs-6 pb-1'>{data.other_requirement ? data.other_requirement : "-"}</span>
                            </div>
                        </div>
                        {/* End: Detail field Other Requirements */}
                    </div>
                    {/* End: right column */}
                </div>
            </div>
            {/* End: Modal body */}
        </Modal>,
        modalsRoot
    )
}

export default LeadDetails
